import { secureModeFirmwareVersions } from '../../../../helpers/constants';

export default {
	title: 'settings',
	components: [
		{ title: 'eco_mode', component: 'eco_mode_g2' },
		{
			title: 'enhanced_security',
			component: 'enhanced_security_g2',
			min_ver: secureModeFirmwareVersions,
		},
		{ title: 'device_profile', component: 'pro3em_profile' },
		{ title: 'emeter_measurement', component: 'emeter_measurement' },
		{
			title: 'reverse_measurement_direction',
			component: 'reverse_measurement_direction_monophase',
		},
		{ title: 'change_ct_type', component: 'change_ct_type', min_ver: '1.4.0' },
		{ title: 'emeter_calibration', component: 'emeter_calibration' },
		{
			title: 'channel_from_channel_calibration',
			component: 'channel_from_channel_calibration_g2',
		},
		{ title: 'emeter_stored_data', component: 'emeter_stored_data' },
		{ title: 'delete_stored_data', component: 'delete_stored_data_g2' },
		{
			title: 'reset_energy_counters',
			component: 'reset_energy_counters_g2',
			min_ver: '1.2.0',
		},
		{ title: 'emeter_alarms', component: 'emeter_alarms', min_ver: '2.0.0' },
		{ title: 'device_name', component: 'device_name_g2' },
		{ title: 'firmware_version', component: 'firmware_update' },
		{ title: 'geo_location_and_time_zone', component: 'location_g2' },
		{ title: 'device_reboot', component: 'device_reboot' },
		{ title: 'factory_reset', component: 'factory_reset' },
		{ title: 'device_information', component: 'device_information' },
	],
};
